module.exports = __webpack_public_path__ + "static/media/mercado-modelo-logo-branding-768x534.e34b5145.jpg";